export default __webpack_public_path__ + "static/media/Andrada.24475d9b.jpg";